import { Controller } from "@hotwired/stimulus"
import { generateFingerprint, detectDeviceType, getVisitorId } from "../src/device_fingerprint"

// Fingerprint controller using our self-hosted device fingerprint for customer
// identification. This allows reconnecting customer chats across page loads
// without any third-party library or API.
export default class extends Controller {
  static values = {
    websiteId: String,
    endpoint: String
  }

  connect() {
    // Check if fingerprint was already passed via URL params (embed mode)
    // In that case, the server already has the fingerprint - no need to send again
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('fingerprint')) {
      console.log('[Fingerprint] Fingerprint already in URL, skipping client-side generation')
      return
    }

    this.initFingerprint()
  }

  async initFingerprint() {
    try {
      const fingerprint = await generateFingerprint()

      if (!fingerprint) {
        console.error('[Fingerprint] No fingerprint generated')
        return
      }

      console.log('[Fingerprint] Generated fingerprint:', fingerprint.substring(0, 16) + '...')

      // Send fingerprint to server. visitor_id is a stable first-party GUID
      // (the primary identifier); the fingerprint is the secondary fallback.
      await this.sendFingerprint({
        fingerprint: fingerprint,
        visitor_id: getVisitorId(),
        device_type: detectDeviceType(),
        user_agent: navigator.userAgent
      })
    } catch (error) {
      console.error('[Fingerprint] Error generating fingerprint:', error)
    }
  }

  async sendFingerprint(data) {
    const endpoint = this.endpointValue
    if (!endpoint) {
      console.warn('[Fingerprint] No endpoint configured')
      return
    }

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data),
        credentials: 'include'
      })

      if (response.ok) {
        const result = await response.json()
        console.log('[Fingerprint] Fingerprint registered:', result)

        // If we got a new session token, update the local reference
        if (result.session_token && window.canvasSessionToken !== result.session_token) {
          console.log('[Fingerprint] Session reconnected with existing customer')
          window.canvasSessionToken = result.session_token
        }
      } else {
        console.error('[Fingerprint] Failed to send fingerprint:', response.status)
      }
    } catch (error) {
      console.error('[Fingerprint] Error sending fingerprint:', error)
    }
  }
}
